import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Divider, Spin, Popover, Typography, Icon } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import styled from 'styled-components';
import { isEmpty } from 'lodash';
import { IoIosArrowDown } from 'react-icons/io';

import PlacementCard from '../../../../../components/uiComponent/placement-card';
import Button from '../../../../../components/uiComponent/button/index';

import { PlacementOptionCardStyleWrapper, ShippingWrapper } from './style';
import AccordionStepper from '../../../../../components/uiComponent/accordionStepper';
import Step1 from './steps/step1';
import StepTwo from './steps/step2/index';
import PackCard from '../../../../../components/uiComponent/pack-card';
import AntdAccordionCard from '../../../../../components/uiComponent/accordion';
import ProgressBar from '../../../../../components/uiComponent/progressBar';
import Modal from '../../../../../components/uiComponent/modal';
import WarningIcon from '../../../../../assets/icons/warning-modal-icon.svg';
import StepThree from './steps/step3';
import TransportCard from '../../../../../components/uiComponent/transports-card';
import StepFour from './steps/step4';
import StepFive from './steps/step5';
import { GetWarehouseShipments, setShipmentStates, GetPackingGroupItems, resetPostShipmentState } from '../../../../../slices/post-shipment';
import { CancelInboundPlan } from '../../../../../slices/shipment-plan.js';
import Stepper from '../../../../../components/uiComponent/newStepper';
import { DeleteModalStyleWrapper } from '../../../../../containers/logistics/orders/warehouse/shipping/style.js';
import {
  CreatePallets,
  DownloadPickList,
  GenerateDeliveryWindowOptions,
  GenerateTransportationOptions,
  SetPackingInformation,
  ConfirmDeliveryWindowOption,
  UpdateShipmentTrackingDetails,
  ConfirmTransportationOptions,
  SaveTransportationDetails,
  ListTransportationOptions,
  ListDeliveryWindowOptions
} from '../../../../../slices/post-shipment';

import { generateExcel, generatePDF } from '../../../../../utils/download-file';
import { GetWorkOrderDetails, resetWorkOrderState } from '../../../../../slices/work-orders';
import { ConfirmPlacementOption } from '../../../../../slices/shipment-plan';
const PlacementOption = () => {
  const { workOrderId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [activeKey, setActiveKey] = useState('1');
  const [activeShipmentIndex, setActiveShipmentIndex] = useState(-1);
  const [collapseAbleDataShow, setCollapseAbleDataShow] = useState(false);
  const [isShowData, setIsShowData] = useState(false);
  const [showTransportGlobal, setShowTransportGlobal] = useState(true);
  const [printBoxGlobal, setPrintBoxGlobal] = useState();
  const [isSubmitPackingInfo, setIsSubmitPackingInfo] = useState(false);
  const [shipmentsData, setShipmentsData] = useState([]);
  const [showPopover, setShowPopover] = useState(false);
  const [downloadPickListLoading, setDownloadPickListLoading] = useState(false);
  const [downloadType, setDownloadType] = useState('');
  const [transportationDetails, setTransportationDetails] = useState([]);
  const [deliveryWindowOptionsLoading, setDeliveryWindowOptionsLoading] = useState(false);
  const [updateShipmentTrackingDetailsLoading, setUpdateShipmentTrackingDetailsLoading] = useState(false);
  const [palletsChangeAllowed, setPalletsChangeAllowed] = useState(false);
  const [checkingAccess, setCheckingAccess] = useState(true);
  const [selectedPlacementOptionId, setSelectedPlacementOptionId] = useState(null);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [isDeleteBox, setIsDeleteBox] = useState(false);


  const {
    shipmentDetails,
    transportationOptions,
    fetchingWarehouseShipments,
    settingPackInformation,
    creatingPallets,
    generatingTransportationOptions,
    generatingDeliveryWindowOptions,
    saveTransportationDetailsLoading,
    confirmingTransportationOption,
    listingTransportationOptions,
    listingDeliveryWindowOptions,
    packingMethod,
    shipmentType,
    packingGroups,
    skuGroupMap,
    packingItems,
    fetchingPackingGroups,
    fetchingPackingItems,
  } = useSelector((state) => state.postShipment || {});
  const { cancelingInboundPlan, confirmingPlacementOption } = useSelector((state) => state.shipmentPlan || {});
  const { inboundPlanId, fetchingOrderItems } = useSelector((state) => state.workOrders || {});
  const { currentUser } = useSelector((state) => state.auth || {});

  const { shipments, placementFee, inboundStatus, placementOptionExpiry, contactDetails: contactInfo } = shipmentDetails || {};
  const { partneredOptions } = transportationOptions || {};

  const [contactDetails, setContactDetails] = useState(contactInfo);
  const [deletedPallets, setDeletedPallets] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  useEffect(() => {
    dispatch(resetPostShipmentState());
    dispatch(resetWorkOrderState());

    dispatch(GetWorkOrderDetails(workOrderId)).then(({ payload }) => {
      const status = payload?.data?.status;

      if (!status || status === 'Draft' || status === 'Cancelled') {
        const redirectPath = currentUser?.role?.id === 5 ? '/work-orders' : '/warehouse-work-orders';
        navigate(redirectPath, { replace: true });
        return;
      }

      setCheckingAccess(false);
      dispatch(GetWarehouseShipments({ workOrderId }));
    });

    return () => {
      dispatch(resetPostShipmentState());
      dispatch(resetWorkOrderState());
    };
  }, [workOrderId, dispatch]);

  useEffect(() => {
    if (currentUser?.role?.id !== 5) return;
    const handlePopState = () => {
      navigate('/work-orders', { replace: true });
    };
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [currentUser, navigate]);

  useEffect(() => {
    if (contactInfo !== undefined) setContactDetails(contactInfo);
  }, [contactInfo]);

  const prevStatusRef = useRef(null);

  useEffect(() => {
    if (!inboundStatus) return;

    // Only update activeKey if the status has actually changed to prevent flickering
    // during transitions where shipments data updates before the status does.
    if (prevStatusRef.current !== inboundStatus) {
      if (packingMethod === 'pack_now') {
        let step = '1';
        if (['Confirmed', 'BOXED'].includes(inboundStatus)) step = '2';
        else if (inboundStatus === 'PACKED') step = '3';
        else if (inboundStatus === 'TRANSPORTATION_CONFIRMED') step = '4';
        setActiveKey(step);
      } else {
        let step = '1'; // Default for pack_later starts at Placement
        if (['BOXED', 'Confirmed'].includes(inboundStatus)) step = '2';
        else if (inboundStatus === 'PACKED') step = '3';
        else if (inboundStatus === 'TRANSPORTATION_CONFIRMED') step = '4';
        
        if (inboundStatus === 'BOXED') {
          setIsSubmitPackingInfo(true);
          setPalletsChangeAllowed(true);
        }
        setActiveKey(step);
      }
      prevStatusRef.current = inboundStatus;
    }
  }, [inboundStatus, packingMethod]);

  useEffect(() => {
    // Keep default activeShipmentIndex (-1) for Global View on initial step load
  }, [activeKey, shipments?.length]);

  useEffect(() => {
    if (packingMethod !== 'pack_now') return;
    if (!inboundStatus) return;
    dispatch(GetPackingGroupItems({ workOrderId }));
  }, [packingMethod, inboundStatus, workOrderId]);

  useEffect(() => {
    if (packingMethod === 'pack_now') return;
    if (Array.isArray(transportationOptions) && transportationOptions.length === 0) return;
    setTransportationDetails(shipmentDetails?.transportationDetails || []);
  }, [shipmentDetails, packingMethod]);

  const downloadPickList = (type) => {
    setDownloadType(type);
    const pathSegments = window.location.pathname.split('/');
    const workOrderId = pathSegments.pop();
    setShowPopover(false);

    setDownloadPickListLoading(true);
    dispatch(DownloadPickList(workOrderId)).then(({ payload }) => {
      if (payload?.success) {
        // shipments is only populated for Pack Later (Pack Now has no location-based picking
        // step to split by shipment); [] here makes the Excel generator fall back to a single
        // sheet, unchanged from before per-shipment tabs existed. PDF stays single-section.
        const { pickList = [], orderName, shipments = [] } = payload;
        (type === 'excel' || type === 'both') && generateExcel({ pickList, orderName, shipments });
        (type === 'pdf' || type === 'both') && generatePDF({ pickList, orderName });
      }
      setDownloadPickListLoading(false);
    });
  };

  const formatDateForAmazon = (dateString) => {
    const dateWithDayEnd = new Date(`${dateString}T23:59:00.000Z`);
    return dateWithDayEnd.toISOString().replace('.000', '');
  };

  const mappedShipmentData = (shipments?.length > 0) ? shipments.map(({
    amazon_warehouse_id,
    amazon_shipment_id,
    amazon_shipment_confirmation_id,
    shipment_items_info
  }) => {
    const { totalQuantity = 0, totalBoxedQuantity = 0 } = (shipment_items_info || []).reduce((acc, item) => {
      const quantity = Number(item?.quantity) || 0;
      const boxedQuantity = Number(item?.boxed_quantity) || 0;

      acc.totalQuantity += quantity;
      acc.totalBoxedQuantity += boxedQuantity;

      return acc;
    }, { totalQuantity: 0, totalBoxedQuantity: 0 });

    return {
      id: amazon_shipment_id,
      title: amazon_shipment_confirmation_id,
      locationCode: amazon_warehouse_id,
      currentProgress: totalBoxedQuantity,
      totalProgress: totalQuantity
    };
  }) : (packingMethod === 'pack_now' && packingGroups?.length > 0) ? packingGroups.map((group) => {
    const groupId = group.packingGroupId;
    const groupItems = group.items || [];
    
    const totalQuantity = groupItems.reduce((acc, item) => acc + (item.quantity || 0), 0);
    const totalBoxedQuantity = (packingItems || []).reduce((acc, item) => {
      if (skuGroupMap && skuGroupMap[item.msku] === groupId) {
        return acc + (item.boxed_quantity || 0);
      }
      return acc;
    }, 0);

    return {
      id: groupId,
      title: groupId,
      locationCode: 'Group',
      currentProgress: totalBoxedQuantity,
      totalProgress: totalQuantity
    };
  }) : [];

  // "Fully packed" gate for the Submit button. Pack Later already has a shipment at this step, so
  // mappedShipmentData (shipment_items_info: quantity/boxed_quantity, both DB-sourced) is reliable.
  // Pack Now has no shipment yet — mappedShipmentData falls back to packingGroups, whose item
  // quantities come from Amazon's SP-API (listPackingGroupItems) and can arrive without an `items`
  // array at all (get-packing-items.js's fallback when packing_option_id hasn't landed yet),
  // silently reading as "0 required" instead of "not yet known" and letting the button go enabled
  // before anything's actually packed. packingItems is queried directly against our own
  // work_order_items_v2 (ship_quantity) + box_items_v2 (boxed_quantity) — no SP-API involved — so
  // Pack Now checks that instead.
  const isFullyPacked = packingMethod === 'pack_now'
    ? (packingItems || []).length > 0 && packingItems.every(
      (item) => Number(item.quantity) > 0 && Number(item.boxed_quantity || 0) >= Number(item.quantity)
    )
    : mappedShipmentData.length > 0 && mappedShipmentData.every(
      ({ currentProgress, totalProgress }) => totalProgress > 0 && currentProgress >= totalProgress
    );

  const transportationShipments = shipments?.map(({
    amazon_shipment_confirmation_id = '',
    amazon_shipment_id,
    destination_address_line_1: address_line1,
    destination_city: city,
    destination_country_code: country,
    destination_name: name,
    destination_postal_code: postal_code,
    destination_state_or_province_code: state,
    is_completed
  }) => {
    const formattedAddress = `${name} ${address_line1} ${city}, ${state} ${postal_code} ${country}`;

    return {
      id: amazon_shipment_id,
      amazon_shipment_confirmation_id,
      address: formattedAddress,
      status: (is_completed || ['PACKED', 'TRANSPORTATION_CONFIRMED', 'SHIPPED'].includes(inboundStatus)) ? 'Completed' : 'Pending'
    };
  }) || [];

  const estimatedShippingFee = transportationDetails?.reduce((sum, option) => {
    const obj = partneredOptions?.find?.(({ transportationOptionId }) => transportationOptionId === option?.transportationOptionId?.partnered) || {};
    return sum + (obj?.quote?.cost?.amount || 0);
  }, 0);

  const getShipmentMode = (detail = {}) => {
    if (packingMethod !== 'pack_now') return shipmentType;
    const raw = detail.shipmentType || detail.shipment_type || shipmentType || 'SP';
    if (raw === 'GROUND_SMALL_PARCEL' || raw === 'SPD') return 'SP';
    if (raw === 'LESS_THAN_TRUCKLOAD') return 'LTL';
    return raw;
  };

  const isSpShipment = (detail = {}) => getShipmentMode(detail) === 'SP';

  const handleSubmitPackingInformation = () => {
    if (isSubmitPackingInfo) {
      const mappedPallets = shipmentsData.flatMap(shipment => {
        const { pallets, amazon_shipment_id: amazonShipmentId } = shipment;

        return pallets
          .map(({
            id,
            noOfPallets,
            height,
            width,
            length,
            weight,
            stackable
          }) => ({
            id,
            noOfPallets: Number(noOfPallets),
            height,
            width,
            length,
            weight,
            isStacked: stackable === 'Yes',
            amazonShipmentId
          }));
      });

      const shipmentsFreightInfo = shipmentsData.map(shipment => {
        const { freightInfo, amazon_shipment_id: amazonShipmentId } = shipment;
        if (freightInfo.class === 'estimate' && (freightInfo.estimatedClass || freightInfo.tempoEstKey)) {
          freightInfo.class = freightInfo.estimatedClass?.toFixed(2)?.toString() || freightInfo.tempoEstKey?.toFixed(2)?.toString();
          delete freightInfo.tempoEstKey;
          delete freightInfo.estimatedClass;
        }

        return {
          freightInfo,
          amazonShipmentId
        };
      });

      const { amazonInboundPlanId: inboundPlanId, shipments } = shipmentDetails || {};

      dispatch(CreatePallets({
        pallets: mappedPallets,
        deletedPallets,
        contactDetails,
        shipmentsFreightInfo,
        inboundPlanId
      }))
        .then(({ payload }) => {
          if (payload?.success) {
            setDeletedPallets([]);
            const shipmentTransportationConfigurations = shipmentsData.map((shipment) => {
              const { amazon_shipment_id, freightInfo, pallets } = shipment;
              const { name, phone: phoneNumber, email, shipDate } = contactDetails || {};
              const detail = transportationDetails?.find(d => d.shipmentId === amazon_shipment_id) || {};
              const isSp = isSpShipment(detail);

              const config = {
                readyToShipWindow: {
                  start: formatDateForAmazon(shipDate)
                },
                shipmentId: amazon_shipment_id
              };

              if (!isSp) {
                if (name && email && phoneNumber) {
                  config.contactInformation = {
                    email,
                    name,
                    phoneNumber
                  };
                }

                const filteredPallets = pallets?.filter(p => Number(p.height) > 0 && Number(p.weight) > 0) || [];
                if (filteredPallets.length > 0) {
                  config.pallets = filteredPallets.map(({
                    height,
                    length,
                    width,
                    weight,
                    noOfPallets,
                    stackable
                  }) => ({
                    dimensions: {
                      height: Number(height),
                      length: Number(length || 48),
                      unitOfMeasurement: 'IN',
                      width: Number(width || 40)
                    },
                    quantity: Number(noOfPallets || 1),
                    stackability: (stackable === 'Yes') ? 'STACKABLE' : 'NON_STACKABLE',
                    weight: {
                      unit: 'LB',
                      value: Number(weight)
                    }
                  }));

                  if (freightInfo?.class && Number(freightInfo.class) > 0) {
                    config.freightInformation = {
                      declaredValue: {
                        amount: Number(freightInfo?.value || 0),
                        code: 'USD'
                      },
                      freightClass: `FC_${Number(freightInfo?.class || 0).toString().replace('.', '_')}`
                    };
                  }
                }
              }

              return config;
            });

            dispatch(GenerateTransportationOptions({
              inboundPlanId,
              placementOptionId: shipments[0]?.amazon_placement_option_id,
              shipmentTransportationConfigurations
            }))
              .then(async ({ payload }) => {
                if (payload?.success) {
                  const requests = shipments.map(({ amazon_shipment_id: shipmentId }) =>
                    dispatch(GenerateDeliveryWindowOptions({ inboundPlanId, shipmentId }))
                  );

                  await Promise.all(requests);

                  // notification['success']({
                  //   message: 'Delivery Window Options Generated Successfully',
                  //   top: 65,
                  // });

                  dispatch(GetWarehouseShipments({
                    workOrderId
                  })).then(() => {
                    const shipmentIds = shipments.map(s => s.amazon_shipment_id);
                    dispatch(ListTransportationOptions({ inboundPlanId, placementOptionId: shipments[0]?.amazon_placement_option_id }));
                    dispatch(ListDeliveryWindowOptions({ inboundPlanId, shipmentIds }));
                    setActiveKey('3');
                    setPalletsChangeAllowed(false);
                  });
                }
              });
          }
        });

      return;
    }

    dispatch(SetPackingInformation(workOrderId))
      .then(({ payload }) => {
        if (payload?.success) {
          dispatch(GetWarehouseShipments({
            workOrderId
          }));
        }
      });
  };

  const handlePackingComplete = () => {
    dispatch(SetPackingInformation(workOrderId)).then(({ payload }) => {
      if (payload?.success) {
        // Status-based routing in the useEffect handles step advancement automatically
        dispatch(GetWarehouseShipments({ workOrderId }));
      }
    });
  };

  const handleCancelInboundPlan = () => {
    dispatch(CancelInboundPlan({
      inboundPlanId,
      workOrderId
    }))
      .then(({ payload }) => {
        if (payload?.success) {
          setIsDeleteBox(false);
          const redirectPath = currentUser?.role?.id === 5 ? `/inventory/work-order/${workOrderId}` : '/warehouse-work-orders';
          navigate(redirectPath, { replace: true });
        }
      });
  };

  const getConfirmBtnDisabledStatus = () => {
    if (!transportationDetails?.length) return true;

    const anyMissingSelection = transportationDetails.some((detail) => {
      const { transportationOptionId, deliveryWindowOptionId, proNumber, carrierType, spdTrackingItems } = detail || {};
      const isSp = isSpShipment(detail);
      const isSpNonPartnered = isSp && carrierType === 'non-partnered';
      // SPD partnered: no delivery window required; SPD non-partnered + LTL: required
      const hasDeliveryWindow = (isSp && !isSpNonPartnered) ? true : !!deliveryWindowOptionId;
      const hasOption = !!(transportationOptionId?.partnered || transportationOptionId?.nonPartnered);
      // SPD (any carrier) or LTL partnered: no pro number; LTL non-partnered only: required
      const hasProNumber = (carrierType === 'partnered' || isSp) ? true : !!proNumber;
      // SPD non-partnered: all entered tracking IDs must be non-empty
      const hasTrackingIds = isSpNonPartnered
        ? (Object.keys(spdTrackingItems || {}).length > 0 && Object.values(spdTrackingItems || {}).every(t => !!t?.trim()))
        : true;
      return !hasDeliveryWindow || !hasOption || !hasProNumber || !hasTrackingIds;
    });

    if (anyMissingSelection) return true;

    // Amazon requires all SPD partnered shipments use the same carrier
    const spPartneredDetails = transportationDetails.filter(d => isSpShipment(d) && d.carrierType === 'partnered');
    if (spPartneredDetails.length > 1) {
      const carrierCodes = spPartneredDetails.map(({ transportationOptionId }) => {
        const optionId = transportationOptionId?.partnered;
        if (!optionId) return null;
        const option = partneredOptions?.find(o => o.transportationOptionId === optionId);
        return option?.carrier?.alphaCode || option?.carrier?.name || null;
      });
      const firstCarrier = carrierCodes[0];
      if (!firstCarrier || carrierCodes.some(c => c !== firstCarrier)) return true;
    }

    return false;
  };


  const handleConfirmShipping = async () => {

    const { amazonInboundPlanId: inboundPlanId } = shipmentDetails || {};

    // Confirm delivery window for LTL and SPD non-partnered
    const needsDeliveryWindowConfirm = transportationDetails.filter(detail =>
      !isSpShipment(detail) || (isSpShipment(detail) && detail.carrierType === 'non-partnered')
    );
    if (needsDeliveryWindowConfirm.length) {
      setDeliveryWindowOptionsLoading(true);
      const dwRequests = needsDeliveryWindowConfirm.map(({ shipmentId, deliveryWindowOptionId }) =>
        dispatch(ConfirmDeliveryWindowOption({
          inboundPlanId,
          shipmentId,
          deliveryWindowOptionId
        }))
      );
      await Promise.all(dwRequests);
      setDeliveryWindowOptionsLoading(false);
    }

    dispatch(ConfirmTransportationOptions({
      inboundPlanId,
      transportationSelections: transportationDetails?.map(({ shipmentId, transportationOptionId }) => ({
        shipmentId,
        transportationOptionId: transportationOptionId?.partnered || transportationOptionId?.nonPartnered
      })) || []
    })).then(async ({ payload }) => {
      if (payload?.success) {
        setUpdateShipmentTrackingDetailsLoading(true);
        const requests = transportationDetails
          .filter(detail => detail.carrierType === 'non-partnered')
          .map((detail) => {
            const { shipmentId, proNumber, spdTrackingItems } = detail;
            if (isSpShipment(detail)) {
              // SPD non-partnered: per-box tracking IDs
              const spdTrackingItemsList = Object.entries(spdTrackingItems || {}).map(([boxId, trackingId]) => ({ boxId, trackingId }));
              return dispatch(UpdateShipmentTrackingDetails({
                inboundPlanId,
                shipmentId,
                trackingDetails: { spdTrackingDetail: { spdTrackingItems: spdTrackingItemsList } }
              }));
            }
            // LTL non-partnered: freight bill number
            return dispatch(UpdateShipmentTrackingDetails({
              inboundPlanId,
              shipmentId,
              trackingDetails: { ltlTrackingDetail: { freightBillNumber: [proNumber] } }
            }));
          });

        await Promise.all(requests);
        setUpdateShipmentTrackingDetailsLoading(false);

        dispatch(GetWarehouseShipments({
          workOrderId
        }));
        setActiveKey('4');
      }
    });
  };

  const handleConfirmPlacementForPackNow = () => {
    const placementOptionId = shipmentDetails?.shipments?.[0]?.amazon_placement_option_id;
    if (!placementOptionId) return;

    dispatch(ConfirmPlacementOption({
      workOrderId,
      placementOptionId
    })).then(({ payload }) => {
      if (payload?.success) {
        handleConfirm(activeKey);
      }
    });
  };

  const handleConfirmPlacementOption = () => {
    if (!selectedPlacementOptionId) return;
    const { amazonInboundPlanId: inboundPlanId } = shipmentDetails || {};

    dispatch(ConfirmPlacementOption({
      workOrderId,
      placementOptionId: selectedPlacementOptionId,
      amazonInboundPlanId: inboundPlanId
    })).then(({ payload }) => {
      if (payload?.success) {
        dispatch(GetWarehouseShipments({ workOrderId }));
        setActiveKey(String(Number(activeKey) + 1));
      }
    });
  };

  const DropdownStyledWrapper = styled.div`
.menu-wrapper-id {
  p {
    margin: 0px;
    padding: 4px 12px;
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    vertical-align: middle;
    color: #4E5969;
    &:hover{
      background: #F5F5F5;
      cursor: pointer;
    }
}
}
`;

const itemsPerPage = 20;

  const getStepTwoComponent = () => (
    <StepTwo
      setIsSubmitPackingInfo={setIsSubmitPackingInfo}
      setPalletsChangeAllowed={setPalletsChangeAllowed}
      palletsChangeAllowed={palletsChangeAllowed}
      deliveryWindowOptionsLoading={deliveryWindowOptionsLoading}
      updateShipmentTrackingDetailsLoading={updateShipmentTrackingDetailsLoading}
      setTransportationDetails={setTransportationDetails}
      transportationDetails={transportationDetails}
      isSubmitPackingInfo={isSubmitPackingInfo}
      activeShipmentIndex={activeShipmentIndex}
      contactDetails={contactDetails}
      setContactDetails={setContactDetails}
      shipmentsData={shipmentsData}
      setShipmentsData={setShipmentsData}
      deletedPallets={deletedPallets}
      setDeletedPallets={setDeletedPallets}
      showTransportGlobal={showTransportGlobal}
      setActiveKey={setActiveKey}
      activeKey={activeKey}
      itemsPerPage={itemsPerPage}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      shipmentType={shipmentType}
    />
  );

  const packStep = {
    key: '1',
    title: 'Pack',
    content: getStepTwoComponent()
  };

  const confirmShippingsStep = {
    key: packingMethod === 'pack_now' ? '2' : '1',
    title: 'Confirm Shippings',
    content: <Step1 setActiveKey={setActiveKey} onPlacementSelect={setSelectedPlacementOptionId} confirmingPlacementOption={confirmingPlacementOption} handleConfirmPlacementOption={handleConfirmPlacementOption} selectedPlacementOptionId={selectedPlacementOptionId} onCancelPlan={() => setIsDeleteBox(true)} cancelingInboundPlan={cancelingInboundPlan} />
  };

  const transportStepPackNow = {
    key: '3',
    title: 'Confirm Transportation',
    content: <StepThree
      showTransportGlobal={showTransportGlobal}
      setActiveKey={setActiveKey}
      shipmentIdOuter={activeShipmentIndex === -1 ? null : shipments[activeShipmentIndex]?.amazon_shipment_id}
      setTransportationDetails={setTransportationDetails}
      transportationDetails={transportationDetails}
      updateShipmentTrackingDetailsLoading={updateShipmentTrackingDetailsLoading}
      deliveryWindowOptionsLoading={deliveryWindowOptionsLoading}
      generatingTransportationOptions={generatingTransportationOptions}
      generatingDeliveryWindowOptions={generatingDeliveryWindowOptions}
      onCancelPlan={() => setIsDeleteBox(true)}
      cancelingInboundPlan={cancelingInboundPlan}
    />
  };

  const transportStepPackLater = {
    key: '3',
    title: 'Confirm Transportation',
    content: getStepTwoComponent()
  };

  const labelsStep = {
    key: '4',
    title: 'Print Labels',
    content: <StepFour
      printBoxGlobal={shipmentDetails?.shipments?.length === 1 ? printBoxGlobal : true}
      shipments={shipmentDetails?.shipments || []}
      setActiveKey={setActiveKey}
      shipmentType={shipmentType}
      packingMethod={packingMethod}
      transportationDetails={transportationDetails}
      onCancelPlan={() => setIsDeleteBox(true)}
      cancelingInboundPlan={cancelingInboundPlan}
    />
  };


  const stepsData = packingMethod === 'pack_now'
    ? [
        packStep,
        { ...confirmShippingsStep, key: '2' },
        { ...transportStepPackNow, key: '3' },
        { ...labelsStep, key: '4' }
      ]
    : [
        { ...confirmShippingsStep, key: '1' },
        { ...packStep, key: '2' },
        transportStepPackLater,
        labelsStep
      ];

  const PlacementOptionCard = () => {
    return (
      <PlacementOptionCardStyleWrapper>
        <header>
          <p>Placement Option 1</p>
          <p>Total Shipments: <span>{shipments?.length || 0}</span></p>
        </header>
        <Divider />
        <div className='items-wrapper'>
          <div className='items'>
            <p>Placement Services</p>
            <p>${placementFee}</p>
          </div>
          <div className='items time-eta'>
            <p>Expires</p>
            <p>{dayjs(placementOptionExpiry).format('YYYY-MM-DD') || '---'}</p>
          </div>
        </div>
      </PlacementOptionCardStyleWrapper>
    );
  };

  const getSubmitBtnDisabledStatus = () => {
    return (
      creatingPallets ||
      generatingTransportationOptions ||
      generatingDeliveryWindowOptions ||
      fetchingWarehouseShipments || shipmentsData.some(({
        pallets,
        freightInfo
      }) => {
        const { name, phone, email, shipDate } = contactDetails || {};

        if (!pallets?.length) return true;

        const isLTL = shipmentType !== 'SP';

        return (
          !name ||
          !phone ||
          !email ||
          isNaN(Number(phone)) ||
          (Number(phone) <= 0) ||
          !EMAIL_REGEX.test(email) ||
          !shipDate ||
          (isLTL && (!freightInfo?.class || freightInfo?.class === '0.00')) ||
          (isLTL && pallets.some(({
            height,
            weight,
            noOfPallets,
            stackable
          }) =>
            !height || !weight || !noOfPallets ||
            isNaN(Number(height)) || isNaN(Number(weight)) || isNaN(Number(noOfPallets)) ||
            (Number(height) <= 0) || (Number(weight) <= 0) || (Number(noOfPallets) <= 0) ||
            !stackable
          )));
      }));
  };

  const toSnakeCase = (obj) => {
    if (Array.isArray(obj)) return obj.map(v => toSnakeCase(v));
    if (obj !== null && obj.constructor === Object) {
      return Object.keys(obj).reduce((acc, key) => ({
        ...acc,
        [key.replace(/([A-Z])/g, "_$1").toLowerCase()]: toSnakeCase(obj[key])
      }), {});
    }
    return obj;
  };

  const handleSaveBtn = () => {
    const snakeCasedDetails = toSnakeCase(transportationDetails);
    dispatch(SaveTransportationDetails({ workOrderId, transportationDetails: snakeCasedDetails }));
  };

  const isCompleted = completedSteps.includes(activeKey);
  const isDisabled = activeKey !== '0' && !completedSteps.includes(Number(activeKey) - 1);
  const isPackStep = (packingMethod === 'pack_now' && activeKey === '1') || (packingMethod !== 'pack_now' && activeKey === '2');
  const isFullWidth = packingMethod === 'pack_now' && (activeKey === '1' || activeKey === '2');

  const handleConfirm = (key) => {
    downloadPickList('both');
    if (!completedSteps.includes(key)) {
      setCompletedSteps([...completedSteps, key]);

      const currentIndex = stepsData.findIndex((step) => step.key === key);
      if (currentIndex !== -1 && currentIndex < stepsData.length - 1) {
        setActiveKey(Number(activeKey) + 1);
      }
    }
  };

  if (checkingAccess || (fetchingWarehouseShipments && isEmpty(shipmentDetails))) {
    return <Spin tip='Loading...' spinning style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }} />;
  }

  return (
    <>
      <ShippingWrapper>
        {!isFullWidth && (
          <div className='overlay-container-custom'>
            <div className='cards-overlay-wrapper'>
              {/* {activeKey === '1' ?
            <PlacementCard
              cardsData={placementOptions}
              activePlacementIndex={selectedOptions?.placementIndex}
              selectPlacementOption={selectPlacementOption}
            /> : */}
          {/* activeKey === '2' ? */}
          <div>
            {isPackStep && packingMethod !== 'pack_now' ?
              <div className={`global-view-card ${activeShipmentIndex === -1 ? 'active' : ''}`} onClick={() => setActiveShipmentIndex(-1)}>
                <span className='title'>Global view</span>
                <div className='tabs-cards-wrapper'>
                  <p>Total Shipments:</p>
                  <p>{shipments?.length || 0}</p>
                </div>
                {(() => {
                  let total = 0;
                  let current = 0;

                  shipments?.forEach(({ shipment_items_info = [] }) => {
                    shipment_items_info.forEach((item) => {
                      total += Number(item.quantity) || 0;
                      current += Number(item.boxed_quantity) || 0;
                    });
                  });

                  let status = 'grey';
                  if (current === 0) {
                    status = 'grey';
                  } else if (total === current) {
                    status = 'success';
                  } else if (current < total) {
                    status = 'warning';
                  } else {
                    status = 'warning';
                  }

                  return (
                    <ProgressBar
                      simpleProgress
                      status={status}
                      labelText="Status"
                      current={mappedShipmentData?.reduce(
                        (acc, item) => acc + (item?.currentProgress || 0),
                        0
                      )}
                      total={mappedShipmentData?.reduce(
                        (acc, item) => acc + (item?.totalProgress || 0),
                        0
                      )}
                    />
                  );
                })()} 
              </div>
              : (packingMethod === 'pack_now' ? activeKey === '3' : activeKey === '3') ?
              <div className={`global-view-card-wrapper ${activeShipmentIndex === -1 ? 'active' : ''}`} onClick={() => setActiveShipmentIndex(-1)}>
                <AntdAccordionCard
                  title="Global View"
                  shipments={shipments?.length || 0}
                  fee={estimatedShippingFee > 0 ? estimatedShippingFee.toFixed(2) : (placementFee || 0)}
                />
              </div>
              : (packingMethod === 'pack_now' ? activeKey === '4' : activeKey === '4') ?
              <div className={`global-view-card-wrapper ${activeShipmentIndex === -1 ? 'active' : ''}`} onClick={() => setActiveShipmentIndex(-1)}>
                <AntdAccordionCard
                  title="Global View"
                  shipments={shipments?.length || 0}
                  fee={estimatedShippingFee > 0 ? estimatedShippingFee.toFixed(2) : (placementFee || 0)}
                />
              </div> : activeKey === '5' ? <PlacementOptionCard /> : null}
            {isPackStep && packingMethod !== 'pack_now' ? (
              isSubmitPackingInfo ? (
                <TransportCard
                  cardsData={transportationShipments}
                  activeShipmentIndex={activeShipmentIndex}
                />
              ) : (
                <PackCard
                  cardsData={mappedShipmentData}
                  activeShipmentIndex={activeShipmentIndex}
                  setActiveShipmentIndex={setActiveShipmentIndex}
                />
              )
            ) : (activeKey === '1' || activeKey === '2') ? (
              <PackCard
                activeShipmentIndex={activeShipmentIndex}
                setActiveShipmentIndex={setActiveShipmentIndex}
                cardsData={mappedShipmentData}
                placementFee={placementFee}
                inboundStatus={inboundStatus}
                placementOptionExpiry={placementOptionExpiry}
              />
            ) : activeKey === '3' ?
              <TransportCard
                cardsData={transportationShipments}
                activeShipmentIndex={activeShipmentIndex}
                setActiveShipmentIndex={setActiveShipmentIndex}
              /> : activeKey === '4' ?
                <TransportCard
                  cardsData={transportationShipments}
                  activeShipmentIndex={activeShipmentIndex}
                  setActiveShipmentIndex={setActiveShipmentIndex}
                /> : null}
            </div>
            </div>
          </div>
        )}
        {/* <Button className="btn-wrapper" text="Cancel" />*/}
        <div className={`content-area-wrapper ${isFullWidth ? 'full-width' : ''} ${isPackStep ? 'packing-step' : ''}`}>

          {/* <AccordionStepper
            setIsSubmitPackingInfo={setIsSubmitPackingInfo}
            isSubmitPackingInfo={isSubmitPackingInfo}
            setActiveKey={setActiveKey}
            setIsShowData={setIsShowData}
            activeKey={activeKey}
            steps={stepsData}
            activeShipmentIndex={activeShipmentIndex}
            setActiveShipmentIndex={setActiveShipmentIndex}
            contactDetails={contactDetails}
            setContactDetails={setContactDetails}
            shipmentsData={shipmentsData}
            setShipmentsData={setShipmentsData}
            deletedPallets={deletedPallets}
            setDeletedPallets={setDeletedPallets}
          /> */}
          <div className='stepper-layout-wrapper'>
            <Stepper
              steps={stepsData}
              currentStep={Number(activeKey) - 1}
              status="process"
            />
            {
              stepsData.map((step, index) => {
                if (activeKey === step.key) {
                  return (
                    <div key={index} className='step-content'>
                      {step.content}
                    </div>
                  );
                }
              })
            }
          </div>
          <div className={`buttons-wrapper ${(isPackStep || (activeKey === '4' && packingMethod === 'pack_now')) ? 'buttons-wrapper--step2' : ''}`}>
              {((packingMethod === 'pack_now' && activeKey !== '2' && activeKey !== '3') || (currentUser?.role?.id === 5 && packingMethod !== 'pack_now' && activeKey !== '3')) && activeKey !== '4' && (
                <Button
                  text="Cancel Plan"
                  className="danger button"
                  disabled={cancelingInboundPlan || settingPackInformation}
                  onClick={() => setIsDeleteBox(true)}
                />
              )}

            {(isPackStep && !isSubmitPackingInfo) &&
              <Popover overlayClassName="file-down-loa-ded-wrapper" visible={showPopover} content={
                <DropdownStyledWrapper>
                  <div className="menu-wrapper-id">
                    <p onClick={() => downloadPickList('excel')}>By Excel File</p>
                    <p onClick={() => downloadPickList('pdf')}>By PDF File</p>
                  </div>
                </DropdownStyledWrapper>
              } placement="bottom"><Button
                  endIcon={<IoIosArrowDown onClick={(e) => {
                    setShowPopover(!showPopover);
                    e.stopPropagation();
                  }} />}
                  // startIcon={<img src={FileSaveIcon} alt="FileSaveIcon" />}
                  className="outlined button"
                  text={downloadPickListLoading ? `Downloading ${downloadType === 'pdf' ? 'PDF' : downloadType === 'excel' ? 'Excel' : 'Files'}` : 'Download pick list'}
                  disabled={downloadPickListLoading}
                  onClick={() => setShowPopover(!showPopover)}
                /></Popover>}
            {activeKey === '1' && packingMethod === 'pack_now' && (
              <Button
                className="button"
                text={settingPackInformation ? 'Processing...' : 'Submit Packing Information'}
                disabled={settingPackInformation || fetchingWarehouseShipments || !isFullyPacked}
                onClick={handlePackingComplete}
              />
            )}
            {activeKey === '2' && packingMethod !== 'pack_now' &&
              <Button className="button"
                text={isSubmitPackingInfo === true ? 'Submit' : 'Submit Packing Information'}
                onClick={handleSubmitPackingInformation}
                disabled={isSubmitPackingInfo ? getSubmitBtnDisabledStatus() : (settingPackInformation || fetchingWarehouseShipments || !isFullyPacked)}
              />}
            {
              activeKey === '3' && (packingMethod !== 'pack_now' || (!isEmpty(partneredOptions) || !isEmpty(transportationOptions?.nonPartneredOptions))) && !generatingTransportationOptions && !listingTransportationOptions && !fetchingWarehouseShipments &&
              <>
                <div className='footer'>
                  <div className='final-record-items'>
                    <div className='items-wrapper'>
                      <p className='title-text'>Fees Details</p>
                      <div className='content-items-wrapper'>
                        <p>Placement Fees:</p>
                        <p>${placementFee || 0}</p>
                      </div>
                      <div className='content-items-wrapper'>
                        <p>Estimate Shipping Fees:</p>
                        <p>${Number(estimatedShippingFee || 0)?.toFixed(2)}</p>
                      </div>
                      <Divider />
                      <div className='content-items-wrapper final-record'>
                        <p>Total Estimated Fees:</p>
                        <p>${Number((placementFee || 0) + (estimatedShippingFee || 0))?.toFixed(2)}</p>
                      </div>
                    </div>
                    <div className='buttons-wrapper-step3'>
                      {(packingMethod === 'pack_now' || currentUser?.role?.id === 5) && (
                        <Button
                          text="Cancel Plan"
                          className="danger mb-0"
                          disabled={cancelingInboundPlan}
                          onClick={() => setIsDeleteBox(true)}
                        />
                      )}
                      <Button
                        text={confirmingTransportationOption ? "Confirming..." : "Confirm Shipping"}
                        disabled={getConfirmBtnDisabledStatus() || confirmingTransportationOption || deliveryWindowOptionsLoading || updateShipmentTrackingDetailsLoading || listingTransportationOptions || listingDeliveryWindowOptions}
                        onClick={handleConfirmShipping}
                      />
                    </div>
                  </div>
                </div>
              </>
            }

          </div>
        </div>
      </ShippingWrapper>
            <Modal
              saveText={cancelingInboundPlan ? <span><Icon type="loading" style={{ marginRight: 6, color: '#1565D8' }} />Yes</span> : 'Yes'}
              className="Delete-modal-wrapper-item"
              onClose={() => setIsDeleteBox(false)}
              onSave={handleCancelInboundPlan}
              buttonDisabled={cancelingInboundPlan}
              closeText="No"
              centerAlign
              size="small"
              open={isDeleteBox}
              removeIcon
            >
              <DeleteModalStyleWrapper>
                <div className='delete-modal-wrapper'>
                  <img src={WarningIcon} alt='WarningIcon' title='WarningIcon' />
                  <Typography fontSize={24} component="h3" marginTop={3}>Warning</Typography>
                  <span className='modal-body'>
                  <p>Are you sure you want to cancel this Plan?</p>
                  </span>
                </div>
              </DeleteModalStyleWrapper>
            </Modal>
    </>
  );
};

export default PlacementOption;
